/*
 * @Author: edvardchen
 * @Date: 2018-01-16 16:22:51
 * @Last Modified by: jerryfwang
 * @Last Modified time: 2020-08-07 16:59:58
 */

// @flow
import { type Dispatch, type GetState } from '../types';

import { localStorage, offset, track, onVisibilityChange, getBusinessType, commentExpWhiteList } from '../../utility';

import { makeFetchUserHonorInfoEx } from './actions';

export const TWEET_SUCCESS = 'comment/TWEET_SUCCESS';
export const tweetSuccess = (payload: mixed) => ({ type: TWEET_SUCCESS, payload });

const errorMsg = '评论成功，但是数据异常';
const FAKE_COMMENT_CACHE_KEY = 'user_fake_comment';
export const makeTweetSuccess = (data: *, { manualScroll }: { manualScroll: boolean } = {}) => async (
  dispatch: Dispatch,
  getState: GetState,
) => {
  if (!__CLIENT__) {
    return;
  }
  if (typeof data !== 'object') {
    console.error(errorMsg, data);
    throw new Error(errorMsg);
  }
  console.log('====x5TweetSuccess====', data);
  const {
    postInfo: { postId, circleId },
    user,
    grayConfig,
  } = getState();
  const { content, ...rest } = data;
  const comment = {
    ...rest,
    content: content && decodeURIComponent(content),
    postId,
    circleId,
  };
  localStorage.setItem(FAKE_COMMENT_CACHE_KEY, comment);
  dispatch(tweetSuccess(comment));

  // 埋点
  track({
    location: getBusinessType(),
    object: 'comment',
    action: 'reply',
    id: postId,
    whiteList: commentExpWhiteList(),
    grayConfig,
  });

  if (!manualScroll) {
    // 默认会滚动至全部评论锚点
    const allEl = window.document.querySelector('#allComments');
    if (allEl) {
      const { top } = offset(allEl);
      window.scrollTo(0, top);
    }
  }

  if (user && user.circleUserId) {
    const users = [
      {
        eAccountType: user.type || 0,
        sUserId: user.circleUserId,
      },
    ];
    dispatch(makeFetchUserHonorInfoEx({ users }));
  }
};

export const makeDelFakeComment = (id: string) => async () => {
  const old = localStorage.getItem(FAKE_COMMENT_CACHE_KEY);
  if (!old) {
    return;
  }

  if (old.id === id) {
    localStorage.setItem(FAKE_COMMENT_CACHE_KEY);
  }
};

export const makeInsertFakeComment = () => async (dispatch: Dispatch, getState: GetState) => {
  const old = localStorage.getItem(FAKE_COMMENT_CACHE_KEY);
  if (!old) {
    return;
  }
  const {
    postInfo: { postId },
  } = getState();
  if (old.postId === postId && old.parentCommentId) {
    dispatch(tweetSuccess(old));
  }
};

/**
 * 监听本地缓存的假评论变化
 */
export const makeListenToFakeComment = (() => {
  let listened = false;
  return () => async (dispatch: Dispatch) => {
    if (!__CLIENT__) {
      return;
    }
    if (listened) {
      return;
    }
    listened = true;

    onVisibilityChange((event, hidden: boolean) => {
      if (hidden) {
        return;
      }
      dispatch(makeInsertFakeComment());
    });
  };
})();
